import { Component } from 'react'

class ImageDevice extends Component {
  render() {
    const { stepData } = this.props
    const content =
      stepData && stepData.packageFile.location.length > 1
        ? stepData.packageFile.location
        : stepData && stepData.lcdImage

    return (
      <div className="phone-container col-md-5">
        {content && (
          <>
            {stepData.packageFile.location.length > 1 && (
              <object width={300} height={600} key={Math.uuid()}>
                <param name="movie" value={content} />
                <embed src={content} width={300} height={600} />
              </object>
            )}
            {stepData.packageFile.location.length <= 1 && (
              <object
                width={stepData && 300}
                height={stepData && 600}
                data={content}
              />
            )}
          </>
        )}
      </div>
    )
  }
}

export default ImageDevice
